import { IconProps } from "./HomeIcon";

const DoubleLeftArrowIcon = ({ color = "#CCCCCC" }: IconProps) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 3465526">
        <path
          id="Vector 1"
          d="M11 1L6 6L11 11"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector 2"
          d="M6 1L0.999999 6L6 11"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default DoubleLeftArrowIcon;
